<template>
	<div>
		<div class="tab-scroll-container">
			<ul class="tab-pane">
				<li v-for="(item, index) in openTab" @contextmenu.prevent="openMenu(item,$event,index)" :key=" index" @click="tabClick(item.route)"
				 class="tab-pane-item" :style="active(item.route)">
					{{item.title}}
					<i class="el-icon-close" @click.stop="tabRemove(item.route)" v-if="item.name!='首页'"></i>
				</li>
			</ul>
		</div>
		<ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
			<li @click="refreshTab(tabItem)">刷新页面</li>
			<li v-if="tabItem.name!='首页'" @click="closeTab(tabItem)">关闭当前</li>
			<li @click="closeOthersTab(tabIndex)">关闭其他</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'TagsView',
		props: {
			openTab: {
				required: true,
				type: Array,
			},
		},
		computed: {
			activeIndex: {
				get() {
					return this.$store.state.app.activeIndex;
				},
				set(val) {
					this.$store.commit('app/set_active_index', val);
				}
			},
			theme() {
				return this.$store.getters['settings/theme'];
			}
		},
		data() {
			return {
				visible: false,
				top: 0,
				left: 0,
				tabItem: {},
				tabIndex: 0,
			}
		},
		watch: {
			//观察visible的变化，来触发关闭右键菜单，调用关闭菜单的方法
			visible(value) {
				if (value) {
					document.body.addEventListener('click', this.closeMenu)
				} else {
					document.body.removeEventListener('click', this.closeMenu)
				}
			}
		},
		methods: {
			/**
			 * @param {Object} tag 右键当前选中的tab
			 * @param {Object} e 事件
			 * @param {Object} index 当前下标
			 */
			openMenu(tag, e, index) {
				const menuMinWidth = 105
				this.left = e.clientX;
				this.top = e.clientY
				this.visible = true
				this.tabItem = tag
				this.tabIndex = index
			},
			closeMenu() {
				this.visible = false
			},
			active(tabRoute) {
				let styleParem = {
					'background-color': this.theme,
					'color': '#fff',
					'border-color': this.theme
				}
				return this.activeIndex == tabRoute ? styleParem : '';
			},
			//刷新路由
			refreshTab(tabItem) {
				//1.根据下标 删除当前缓存页面 name
				this.$store.commit('app/delete_cachedViews', tabItem.name);
				//2.然后重定向
				this.$nextTick(() => {
					this.$replace({
						path: '/redirect',
						query: {
							redirect: tabItem.route
						}
					})
				});
			},
			//关闭当前选项卡
			closeTab(tabItem) {
				this.tabRemove(tabItem.route);
			},
			//关闭其他选项卡
			closeOthersTab(tabIndex) {
				this.$store.dispatch('app/delNotCurrentTabs', tabIndex).then((res) => {
					//当页面只有一个选项卡时或者只有他自己时 ，就不走关闭其他逻辑，就没必要了
					if (res[res.length - 1].route != this.activeIndex) {
						//赋值选项卡中 最后一个 路由 为当前路由
						this.$store.commit('app/set_active_index', res[res.length - 1].route);
						this.$router.push(this.activeIndex)
					}
				});

			},
			//tab标签点击时，切换相应的路由
			tabClick(tab) {
				//点击tab让 左边导航栏成选中 状态
				//重复 点击 tab 添加路由会报错（但不影响） 用catch捕捉 就看不见
				this.$router.push(tab).catch(err => err);
			},
			//移除tab标签
			tabRemove(tabRoute) {
				//删除当前路由
				this.$store.commit('app/delete_tabs', tabRoute);
				//如果点击是页面最后一个 tab  删除后 从 openTab 最后一个设置为当前路由
				if (this.activeIndex === tabRoute) {
					// 设置当前激活的路由
					if (this.openTab && this.openTab.length >= 1) {
						//赋值选项卡中 最后一个 路由 为当前路由
						this.$store.commit('app/set_active_index', this.openTab[this.openTab.length - 1].route);
						this.$router.push(this.activeIndex)
					} else {
						this.$go("/login");
					}
				}
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">
	.tab-scroll-container {
		white-space: nowrap;
		position: relative;
		overflow: hidden;
		width: 100%;
	}

	.tab-pane {
		display: flex;
		font-size: 13px;
		flex-direction: row;
		text-align: center;
	}

	.tab-pane-item {
		list-style: none;
		height: 26px;
		line-height: 26px;
		font-size: 13px;
		margin-left: 5px;
		padding: 0 6px;
		position: relative;
		box-sizing: border-box;
		border: 1px solid #d8dce5;
		cursor: pointer;
	}

	.tab-pane-item .el-icon-close {
		border-radius: 50%;
		text-align: center;
		transition: all .3s cubic-bezier(.645, .045, .355, 1);
		margin-left: 5px;

		&:hover {
			background-color: #d8dce5;
			color: #FFFFFF;
		}
	}

	.contextmenu {
		margin: 0;
		background: #fff;
		z-index: 3000;
		position: absolute;
		list-style-type: none;
		padding: 5px 0;
		border-radius: 4px;
		font-size: 12px;
		font-weight: 400;
		color: #333;
		box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

		li {
			margin: 0;
			padding: 7px 16px;
			cursor: pointer;

			&:hover {
				background: #eee;
			}
		}
	}
</style>
